import { createContext } from 'react';
import { shouldReduceCacheTimeForDevEnv } from '../app/utils';
import { TranslationContextProps, TranslationStateContextProps } from './types';

export const GENERAL_MODULE_NAME = 'label';

export const FETCH_TRANSLATION_URL = '/translation/common';
export const TRANSLATIONS_PERSIST_KEY = 'TRANSLATIONS';
export const TRANSLATIONS_CACHE_TIMEOUT = shouldReduceCacheTimeForDevEnv() ? 60000 : 1800000;

export const TranslationContext = createContext<TranslationContextProps>({
	translate: () => {
		//should throw error, but first fix tests providers
		//throw new Error('Didn\'t implemented method');
		return '';
	},
	tryFetchTranslations: () => {
		//should throw error, but first fix tests providers
		//throw new Error('Didn\'t implemented method');
	},
});

export const translationContextStateDefaults = {
	translations: {},
	isInitialized: false,
};

export const TranslationContextState = createContext<TranslationStateContextProps>(translationContextStateDefaults);
